export default __webpack_public_path__ + "static/260-330-9534a5b6ec6f0aaedcc9e1ba4cf6c785.jpg";